var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChat = function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 6.25v14.097l2.61-2.182a1.73 1.73 0 0 1 1.124-.415H20V6.25zm3.256 12.678.478.572v-.019zm.479.553v.02l.162.194.013-.01zm.097.269H20.25A1.75 1.75 0 0 0 22 18V6a1.75 1.75 0 0 0-1.75-1.75H3.75A1.75 1.75 0 0 0 2 6v14.895a1.75 1.75 0 0 0 2.866 1.335l.004-.003z",
    clipRule: "evenodd"
  })));
};
export default SvgIconChat;